import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=520cad74&scoped=true&"
import script from "./InputFile.vue?vue&type=script&lang=ts&"
export * from "./InputFile.vue?vue&type=script&lang=ts&"
import style0 from "./InputFile.vue?vue&type=style&index=0&id=520cad74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520cad74",
  null
  
)

export default component.exports